export const environment = {
  production: true,
  apiUrl: 'https://api.crmgaspre.com',
  developmentUrl: 'http://localhost:3000',
  notificationVapidPublicKey: 'BBi022GNM_diqv_0YrrHjO55XvD3a63uYW7324mwLU6llJlp-GGxG8n9Bvk8egGGq2WEJCXEVOX6NbdfdP_307U'
};
